import { useEffect, useState, useCallback } from 'react';
import { api } from './api';

export function useFetch(path, deps = [], poll = 0) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get(path);
      setData(data);
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);

  useEffect(() => {
    let active = true;
    reload();
    let id;
    if (poll) id = setInterval(() => active && reload(), poll);
    return () => { active = false; if (id) clearInterval(id); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, loading, error, reload };
}
